import script from "./SharedDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./SharedDialog.vue?vue&type=script&setup=true&lang=js"

import "./SharedDialog.vue?vue&type=style&index=0&id=148f0c14&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-148f0c14"]])

export default __exports__